// extracted by mini-css-extract-plugin
export default {"FooterModal":"VerifyModal_FooterModal__L0gIO","previous":"VerifyModal_previous__bVqGZ","Phone":"VerifyModal_Phone__iniap","ContactSecretary":"VerifyModal_ContactSecretary__W0c0R"};